import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { JobsView } from './Jobs';

export const InstallerView: React.FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/jobs`}>
        <JobsView />
      </Route>

      <Route>
        <Redirect to={`${path}/jobs`} />
      </Route>
    </Switch>
  );
};
